import { styled } from '@mui/material'

import { BaseContainer } from '../../configs/styles/BaseGrid'

export const Container = styled(BaseContainer)`
  &.MuiGrid-container {
    height: 100%;
  }
`
